import {ProductExDetailType} from "../interface";

interface PropsType {
    product: ProductExDetailType
}

export default function Section2({product}: PropsType) {
    const productDetail = product.productDetail

    return <>
        <h5 className="subheading">품목 정보</h5>
        <table className="table table-bordered my_table">
            <thead>
            <tr>
                <th style={{width: "16.66%"}}>벤더</th>
                <th style={{width: "16.66%"}}>카테고리</th>
                <th style={{width: "16.66%"}}>품목</th>
                <th style={{width: "16.66%"}}>규격</th>
                <th style={{width: "16.66%"}}>대분류</th>
                <th style={{width: "16.66%"}}>중분류</th>
            </tr>
            </thead>
            <tbody>
            <tr>
                <td className="text-center">{productDetail.vendor}</td>
                <td className="text-center">{productDetail.category}</td>
                <td className="text-center">{productDetail.newTxtNmItem}</td>
                <td className="text-center">{productDetail.newTxtStndItem}</td>
                <td className="text-center">{productDetail.majorCategory}</td>
                <td className="text-center">{productDetail.subCategory}</td>
            </tr>
            </tbody>
        </table>
    </>
}